import type { EmailTemplateEntity } from '@/api/entity_types/EmailTemplate';
import type { EsignatureTemplateEntity } from '@/api/entity_types/EsignatureTemplate';
import type { SmsTemplateEntity } from '@/api/entity_types/SmsTemplate';
import { computed } from 'vue';

export type TemplateEntityOption =
  | { type: 'email'; data: EmailTemplateEntity }
  | { type: 'sms'; data: SmsTemplateEntity }
  | { type: 'esignature'; data: EsignatureTemplateEntity };

export const useTemplateRow = (template: TemplateEntityOption) => {
  const description = computed(() => {
    if (template.type === 'email') return template.data.subject;
    if (template.type === 'sms') return template.data.body;
    return '';
  });

  const workflows = computed(() => (template.type === 'esignature' ? [] : (template.data.workflows ?? [])));

  const deleteDisabled = computed(() => workflows.value.length > 0);

  const deleteTooltip = computed(() => {
    const count = workflows.value.length;
    if (count === 0) return 'Delete';
    return `Remove from ${count} workflow${count === 1 ? '' : 's'} to delete`;
  });

  const showDeleteButton = () => {
    if (template.type === 'esignature') return !template.data.name.includes('Humaniz - ');
    return true;
  };

  return { description, workflows, deleteDisabled, deleteTooltip, showDeleteButton };
};
